import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "event-icon" }
const _hoisted_2 = { class: "event-text-content" }
const _hoisted_3 = {
  key: 0,
  class: "event-title"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "skip-controls" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "skip-counter"
}

import { computed, ref } from 'vue';
import { useGameStore } from '@/stores/gameStore';
import type { GameEvent } from '@/types/game';


export default /*@__PURE__*/_defineComponent({
  __name: 'DayResultsPanel',
  setup(__props) {

const gameStore = useGameStore();

const eventIcons: Record<string, string> = {
    kill: '💀',
    save: '🛡️',
    no_kill: '🌙',
    lynch_result: '⚖️',
    lynch_tie: '🤷',
    joke_vote_result: '🤡',
    joke_vote_tie: '🤔',
    day_start_narration: '☀️',
    night_start_narration: '🌃',
    voting_start_narration: '🗳️',
};

const hasConfirmed = ref(false);

const isAlive = computed(() => gameStore.myPlayer?.is_alive ?? false);

const buttonText = computed(() => {
    if (!isAlive.value) return 'Ожидание живых игроков...';
    return hasConfirmed.value ? 'Ожидание других...' : 'Далее';
});

const formatText = (text: string) => text.replace(/{{{(.*?)}}}/g, '<strong class="player-name-highlight">$1</strong>');

const resultItems = computed(() => {
    return (gameStore.room?.last_events ?? []).map((event: GameEvent) => {
        const narration = event.narration || event.summary || event.text || '';
        return {
            icon: eventIcons[event.type] || '🔹',
            title: event.title,
            narration: formatText(narration)
        };
    });
});

const confirmRead = () => {
    if (!hasConfirmed.value && isAlive.value) {
        hasConfirmed.value = true;
        gameStore.confirmReadResults();
    }
};

const handleOverlayClick = () => {
    confirmRead();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "results-overlay",
    onClick: handleOverlayClick
  }, [
    _createElementVNode("div", {
      class: "results-content",
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resultItems.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "event-item"
        }, [
          _createElementVNode("span", _hoisted_1, _toDisplayString(item.icon), 1),
          _createElementVNode("div", _hoisted_2, [
            (item.title)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_3, _toDisplayString(item.title), 1))
              : _createCommentVNode("", true),
            _createElementVNode("p", {
              class: "event-narration",
              innerHTML: item.narration
            }, null, 8, _hoisted_4)
          ])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: _normalizeClass(["btn skip-btn", { 'btn-secondary': hasConfirmed.value }]),
          onClick: confirmRead,
          disabled: hasConfirmed.value || !isAlive.value
        }, _toDisplayString(buttonText.value), 11, _hoisted_6),
        (_unref(gameStore).room)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Прочитали: " + _toDisplayString(_unref(gameStore).room.confirmed_players_count) + " / " + _toDisplayString(_unref(gameStore).room.active_player_count), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})